"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sizing = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("../components");
var Customize_1 = require("./Customize");
var Percentage_1 = require("./Percentage");
var Pixel_1 = require("./Pixel");
var Sizing = function () { return (react_1.default.createElement(components_1.Doc, { title: "Sizing" },
    react_1.default.createElement(Pixel_1.Pixel, null),
    react_1.default.createElement(Percentage_1.Percentage, null),
    react_1.default.createElement(Customize_1.SizeCustomize, null))); };
exports.Sizing = Sizing;
